import React, { useState, useEffect } from "react";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { GOOGLE_CLOUD_API_KEY } from "../../../../utils/generalData";
import { useSelector, useDispatch } from "react-redux";
import CurrenLocationIcon from "../../../../assets/media/icon.svg";
import {
  connectOrderSocket,
  disConnectOrderSocket,
} from "../../../../store/slices/order";
import connectSocket from "../../../../services/socket/connection";
import Alert from "@mui/material/Alert";

var carrier_located_marker = null;
var infowindow = null;

const RouteMap = ({ orderDetail }) => {
  const google = window.google;
  const [map, setMap] = useState();
  const [mapRef, setMapRef] = useState(undefined);

  const [distanceMatrix, setDistanceMatrix] = useState(null);
  const [origin, setOrigin] = useState(null);
  const [destination, setDestination] = useState(null);
  const [totalrouteLenght, setTotalrouteLenght] = useState(null);
  const [carrierLocation, setCarrierLocation] = useState(null);
  const [carrierLocationAfterTime, setCarrierLocationAfterTime] =
    useState(null);

  const [originLocation, setOriginLocation] = useState(null);
  const [destinationLocation, setDestinationLocation] = useState(null);
  const [directionsService, setDirectionsService] = useState(null);
  const [directionsRenderer, setDirectionsRenderer] = useState(null);

  const [locatedHour, setLocatedHour] = useState(new Date().getHours());
  const [locatedMinute, setLocatedMinute] = useState(new Date().getMinutes());

  const useType = useSelector((e) => e.basicInfo.userDetails.user_type);
  const carrier_watch_latLng = useSelector(
    (state) => state.carrierPosition.watchPosition
  );
  const isSocketConnected = useSelector(
    (state) => state.order.isSocketConnected
  );
  const orderSocket = useSelector((state) => state.order.socket);

  const accessToken = JSON.parse(localStorage.getItem("auth_token"))?.access;

  const dispatch = useDispatch();

  const render = (status) => {
    if (status === Status.LOADING) return <h3>{status} ..</h3>;
    if (status === Status.FAILURE) return <h3>{status} ...</h3>;
    return null;
  };

  useEffect(() => {
    if (orderDetail.load_post_obj) {
      setOriginLocation({
        lat: Number(orderDetail.load_post_obj.origin_latitude),
        lng: Number(orderDetail.load_post_obj.origin_longitude),
      });

      setDestinationLocation({
        lat: Number(orderDetail.load_post_obj.destination_latitude),
        lng: Number(orderDetail.load_post_obj.destination_longitude),
      });

      setOrigin(orderDetail.load_post_obj.origin_address);
      setDestination(orderDetail.load_post_obj.destination_address);
    }
  }, [orderDetail]);

  useEffect(() => {
    if (useType) {
      if (useType === "carrier") {
        setCarrierLocationAfterTime(carrier_watch_latLng);
      } else {
        !carrier_located_marker && setCarrierLocationAfterTime(null);
      }
    }
  }, [useType, carrier_watch_latLng]);

  useEffect(() => {
    // init map
    if (mapRef && !map) {
      setMap(
        new google.maps.Map(mapRef, {
          center: {
            lat: 25.328624,
            lng: 89.532854,
          },
          zoom: 10,
        })
      );

      setDirectionsService(new google.maps.DirectionsService());
      setDirectionsRenderer(new google.maps.DirectionsRenderer());
      setDistanceMatrix(new google.maps.DistanceMatrixService());
    }
  }, [mapRef, google, map]);

  useEffect(() => {
    if (map && orderDetail.load_post_obj) {
      directionsRenderer.setMap(map);

      directionsService
        .route({
          origin: {
            lat: Number(orderDetail.load_post_obj.origin_latitude),
            lng: Number(orderDetail.load_post_obj.origin_longitude),
          },
          destination: {
            lat: Number(orderDetail.load_post_obj.destination_latitude),
            lng: Number(orderDetail.load_post_obj.destination_longitude),
          },
          travelMode: google.maps.TravelMode.DRIVING,
          unitSystem: google.maps.UnitSystem.IMPERIAL,
        })
        .then((response) => {
          directionsRenderer.setDirections(response);

          let direction_length =
            response.routes[0].legs[0].distance.text.split(" ")[0];

          if (response.routes[0].legs[0].distance.text.includes("mi")) {
            setTotalrouteLenght(direction_length);
          } else {
            setTotalrouteLenght((direction_length * 0.000189394).toFixed(4));
          }
        })
        .catch((e) => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, orderDetail]);

  const marker_info_content = (hour, minute) =>
    `<p className="map-marker-info"> This location located at <span>${hour}:${minute}.</span> </p>`;

  useEffect(() => {
    if (map && carrierLocationAfterTime) {
      if (carrier_located_marker === null) {
        carrier_located_marker = new google.maps.Marker({
          position: carrierLocationAfterTime,
          map,
          icon: CurrenLocationIcon,
        });

        infowindow = new google.maps.InfoWindow({
          content: marker_info_content(locatedHour, locatedMinute),
          maxWidth: 360,
        });

        carrier_located_marker.addListener("click", () => {
          infowindow.open({
            anchor: carrier_located_marker,
            map,
            shouldFocus: false,
          });
        });

        map.setZoom(15);
        map.panTo(carrierLocationAfterTime);
      } else {
        carrier_located_marker.setPosition(carrierLocationAfterTime);
        carrier_located_marker.setMap(map);
        infowindow.setContent(marker_info_content(locatedHour, locatedMinute));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, carrierLocationAfterTime, locatedHour, locatedMinute]);

  // Connect order socket
  useEffect(() => {
    if (!isSocketConnected && useType !== "carrier") {
      dispatch(
        connectSocket(
          `/order/?Authorization=${accessToken}`,
          connectOrderSocket,
          disConnectOrderSocket
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  useEffect(() => {
    if (orderSocket && useType !== "carrier") {
      orderSocket.send(
        JSON.stringify({
          command: "join_room",
        })
      );
    }
  }, [orderSocket, useType]);

  useEffect(() => {
    if (orderSocket && useType !== "carrier") {
      orderSocket.onmessage = (event) => {
        var data_parse = JSON.parse(event.data);
        if (orderDetail?.tracking_id === data_parse.tracking_id) {
          setCarrierLocation(data_parse.carrier_location);
        }
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderSocket, isSocketConnected, orderDetail]);

  useEffect(() => {
    if (carrierLocation && map && useType !== "carrier") {
      if (carrierLocationAfterTime === null) {
        setCarrierLocationAfterTime(carrierLocation);
        setLocatedHour(new Date().getHours());
        setLocatedMinute(new Date().getMinutes());
      } else {
        const refreshInterval = setInterval(() => {
          setCarrierLocationAfterTime(carrierLocation);
          setLocatedHour(new Date().getHours());
          setLocatedMinute(new Date().getMinutes());

          carrier_located_marker.setPosition(carrierLocation);
          carrier_located_marker.setMap(map);
        }, 10000);
        return () => clearInterval(refreshInterval);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carrierLocation, carrierLocationAfterTime, map]);

  return (
    <section id="load-post-google-map">
      <div className="container theme-section">
        <h1>Closest Route From Origin To Destination</h1>

        <div className="order-destintaion-info">
          <ul className="ps-0 mb-5">
            <li>
              <span>From: </span>
              <span>{origin && origin}</span>
            </li>
            <li>
              <span>To: </span>
              <span>{destination && destination}</span>
            </li>
            <li>
              <span>Distance: </span>
              <span>{totalrouteLenght && totalrouteLenght} miles</span>
            </li>
          </ul>
        </div>

        {orderDetail?.status <= 3 &&
          carrierLocationAfterTime === null &&
          useType !== "carrier" && (
            <Alert severity="error"> Currently carrier is not online </Alert>
          )}

        <br></br>
        <Wrapper apiKey={GOOGLE_CLOUD_API_KEY} render={render}>
          <div ref={setMapRef} style={{ width: "100%", height: "500px" }} />
        </Wrapper>
      </div>
    </section>
  );
};

export default React.memo(RouteMap);
